<div>
  <span class="description">
    {{ descriptionKey | translate }}
  </span>
  <div class="form-container">
    <glxy-select-input
      class="form-control"
      *ngIf="originOptions$ | async as originOptions; else loading"
      [label]="'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.ORIGIN' | translate"
      [formControl]="originControl"
      [required]="true"
      [options]="originOptions"
    ></glxy-select-input>
  </div>
  <span class="description">
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_DESCRIPTION' | translate }}
  </span>
  <div class="form-container">
    <glxy-select-input
      class="form-control"
      [label]="'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS' | translate"
      [formControl]="orderStatusControl"
      [required]="true"
      [options]="orderStatusOptions"
    ></glxy-select-input>
  </div>
</div>

<ng-template #loading>
  <div class="side-drawer-shimmer-container">
    <span class="selector stencil-shimmer"></span>
  </div>
</ng-template>
